import { Component, OnInit } from '@angular/core';
import { NavParams, AlertController, PopoverController } from '@ionic/angular';
import { AuthenticationService, User } from './../../../services/authentication.service';
import { UtilService } from './../../../services/util.service';
import { TermService } from './../../../services/term.service';
import { Router, RouterEvent } from '@angular/router';
import { SocketService } from './../../../services/socket.service';
import { NavController, ModalController, ActionSheetController, Events } from '@ionic/angular';

@Component({
  selector: 'app-create-user-modal',
  templateUrl: './create-user-modal.component.html',
  styleUrls: ['./create-user-modal.component.scss'],
})
export class CreateUserModalComponent implements OnInit {
	term:any;
  typeSelected: number;

  constructor(
  	private router: Router, 
  	private popoverCtrl: PopoverController, 
  	private authService: AuthenticationService,
  	private navParams: NavParams,
  	private util: UtilService,
  	private modalCtrl: ModalController,
  	private termService: TermService,
  	private alertController: AlertController,
  	private socket: SocketService
  ) { }

  ngOnInit() {
    this.typeSelected = 0;
  	this.term = this.navParams.get('term');
 //  	this.socket.termUpdate().subscribe(data=>{
 //      if(data && data.term_id && this.term._id == data.term_id){
 //      	this.term[data.field.key] = data.field.value;
 //      }
	// });
  }


  closeModal() {
    this.modalCtrl.dismiss();
  }

}
